import Component from "vue-class-component";
import Vue from "vue";
import CommunicationSettingsView from "@/views/settings/communication/CommunicationSettingsView";
import MeasureUnitsView from "@/views/settings/measure-unit/MeasureUnitsSettingsView";
import DimensionsSettingsView from "@/views/settings/dimension/DimensionsSettingsView";
import axios from "axios";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {EVENTBUS_TOPICS, STOMP_TOPICS} from "@/lib/constants";
import {EventBus} from "@/lib/event-bus";
import {Message, Subscription} from "webstomp-client";

@Component({
  components: {DimensionsSettingsView, MeasureUnitsView, CommunicationSettingsView}
})
export default class License extends Vue {
  public licenseKey = '';
  public isLicensed = false;
  public licenseSub!: Subscription;
  private connected = this.$store.getters.cubiscanConnected;
  private waitingForActivation = false;

  public isValidToActivate(): boolean {
    return this.connected && this.licenseKey !== '';
  }

  public created() {
/*    if (localStorage.getItem("isLicensed") === "true") {
      this.$router.push("/");
    }*/
    this.$watch(
      () => this.$store.getters.cubiscanConnected,
      (value: boolean) => {
        this.connected = value;
      }
    );
  }

  public mounted() {
    EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);
    this.websocketConnected(this.$store.state.stompClient.connected);
  }

  public websocketConnected(state: boolean) {
    if (state) {
      this.licenseSub = this.$store.state.stompClient.subscribe(
        STOMP_TOPICS.LICENSE_TOPIC,
        (message: Message) => {
          const successActivation: boolean = JSON.parse(message.body).successActivation;
          const cubiscanModel: string = JSON.parse(message.body).cubiscanModel;
          if (successActivation) {
            UserActionResultSender.showSuccessFeedback('license.activatedSuccess');
            this.$router.push('/');
          } else {
            UserActionResultSender.showErrorFeedback('license.licenseNotActivated');
          }
        }
      );
    }
  }

  public sendActivateLicense() {
    axios.post('/frontend-api/license/activate', {licenseKey: this.licenseKey})
      .then((response) => {
        this.waitingForActivation = response.data.waitForValidationOnDevice;
        UserActionResultSender.showSuccessFeedback('license.activationWait');
      })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      });
  }

  public activateLicense() {
    axios.post('/frontend-api/license/activate', {licenseKey: this.licenseKey})
      .then((response) => {
        this.isLicensed = response.data;
        localStorage.setItem('isLicensed', String(this.isLicensed));
        if (this.isLicensed) {
          UserActionResultSender.showSuccessFeedback('license.activatedSuccess');
        } else {
          UserActionResultSender.showErrorFeedback('license.licenseNotActivated');
        }
        this.$router.push('/');
      })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      });

  }

  public beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.LICENSE);
    if (this.licenseSub !== undefined) {
      this.licenseSub.unsubscribe();
    }
  }
}
